import {
  ApiRoute,
  CreateEvent,
  Event,
  EventSchema,
  EventWithDetail,
  EventWithDetailSchema,
  PageData,
  PageDataSchema,
  QueryEventsRequest,
  getApiRoute
} from "@garther/interfaces";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

export class EventsApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.EVENT),
      requireAuth: true
    });
  }

  async getAvailableEvents(
    options: QueryEventsRequest = { limit: 6, page: 0 }
  ): Promise<PageData<EventWithDetail>> {
    return await this.get("", PageDataSchema(EventWithDetailSchema), {
      params: options,
      requireAuth: false
    });
  }

  async getEventById(eventId: string): Promise<EventWithDetail> {
    return await this.get(`/${eventId}`, EventWithDetailSchema, { requireAuth: false });
  }

  async createEvent(eventData: CreateEvent): Promise<Event> {
    return await this.post("", EventSchema, eventData, { requireAuth: true });
  }

  // async updateEvent(eventId: string, updateData: Partial<Event>): Promise<Event> {
  //   return await this.put(`/${eventId}`, EventSchema, updateData, { requireAuth: true });
  // }

  // async deleteEvent(eventId: string): Promise<Event> {
  //   return await this.delete(`/${eventId}`, EventSchema, { requireAuth: true });
  // }
}

// Export singleton instance
export const eventsApiClient = new EventsApiClient();
